var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelsius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 -5.24534e-07C18.6274 -8.14227e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 -2.34844e-07 18.6274 -5.24539e-07 12C-8.14234e-07 5.37258 5.37258 -2.34842e-07 12 -5.24534e-07ZM19.3147 12C19.3147 7.96018 16.0398 4.68526 12 4.68526C7.96018 4.68526 4.68526 7.96018 4.68526 12C4.68526 16.0398 7.96018 19.3147 12 19.3147C16.0398 19.3147 19.3147 16.0398 19.3147 12Z",
    fill: "url(#paint0_linear_5404_740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5404_740",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: -5.24534e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelsius);
export default __webpack_public_path__ + "static/media/Celsius.ecd1e7bced5b55fad27a2ec3a54b5561.svg";
export { ForwardRef as ReactComponent };